<template>
  <div style="width: 100%">
    <h4 v-if="showHeadline">Tracking-Liste laden</h4>
    <div class="spaces-filter-container">
      <div class="top-bar-left">
        <InputSearch placeholder="Suche" v-model="searchValue"></InputSearch>
        <Checkbox @change="onFilterChanged" v-model="checked['Online']" id="filter-in-progress"
                  title="Online"></Checkbox>
        <Checkbox @change="onFilterChanged" v-model="checked['Desktop']" id="filter-in-progress"
                  title="Desktop"></Checkbox>
        <Checkbox @change="onFilterChanged" v-model="checked['Mobile']" id="filter-checked"
                  title="Mobile"></Checkbox>
        <Checkbox @change="onFilterChanged" v-model="checked['Tablet']" id="filter-built-in"
                  title="Tablet"></Checkbox>
        <AdaButton style="margin-left: auto" title="REFRESH" type="createButton blue" @click="refresh()"></AdaButton>
      </div>
    </div>
    <AdaDatatable v-if="!loading" :scroll="true" :columns="columns" :data="rows" :show-search="false"
                  :size-of-page="10000"
                  @rowClicked="cellClicked" :search-value="searchValue" :table-filters="[tableFilter]"
                  :disable-pagination="true"
                  :transformers="transformers"></AdaDatatable>
    <div v-if="loading" class="loaderContainer">
      <dot-loader id="loader"></dot-loader>
    </div>
  </div>
</template>

<script>
import AdaDatatable from "../../../components/tables/AdaDatatable";
import InputSearch from "../../../components/inputs/InputSearch";
import Transformers from "../../../components/tables/Transformers";
import {RepositoryFactory} from "../../../scripts/RepositoryFactory";
import Checkbox from "../../../components/inputs/Checkbox";
import AdaButton from "../../../components/buttons/AdaButton";

const TrackingListsRepository = RepositoryFactory.get('trackingLists');

export default {
  components: {
    AdaDatatable,
    InputSearch,
    Checkbox,
    AdaButton
  },
  props: {
    showHeadline: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      loading: false,
      tableFilter: {
        propName: 'target_medium',
        allowedValues: []
      },
      checked: {
        "Online": false,
        "Desktop": false,
        "Mobile": false,
        "Tablet": false
      },
      searchValue: '',
      columns: [
        {
          viewName: 'TrackingList',
          propName: 'name',
          sortable: true,
          width: '25%'
        },
        {
          viewName: 'Erstellungsdatum',
          propName: 'created_at',
          sortable: true,
          width: '25%',
          maxWidth: '200px'
        },
        {
          viewName: 'Medium',
          propName: 'target_medium',
          width: '25%',
          maxWidth: '120px'
        },
        {
          viewName: 'Aktion',
          propName: 'action',
          width: '25%',
          maxWidth: '220px'
        }
      ],
      rows: [],
      transformers: [
        {
          propName: 'action',
          transform: function (value) {
            let res = '';
            value.forEach(action => {
              switch (action) {
                case 'select':
                  res += '<button data-type="select" class="select-button">Trackingliste laden</button>';
                  break;
                default:
                  console.error('default case');
              }
            });
            return res;
          }
        },
        {
          propName: 'created_at',
          transform: Transformers.dateTransformer
        },
        {
          propName: 'target_medium',
          transform: function (value) {
            let res = '';
            switch (value.toLowerCase()) {
              case 'online':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;" class="margin-right hover-highlight icon-device-xdigital"></span>';
                break;
              case 'desktop':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;" class="margin-right hover-highlight icon-device-desktop"></span>';
                break;
              case 'mobile':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;" class="margin-right hover-highlight icon-device-mobile"></span>';
                break;
              case 'tablet':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;" class="margin-right hover-highlight icon-device-tablet"></span>';
                break;
            }
            return res;
          }
        }
      ]
    }
  },
  name: "SelectTrackingListFromTable",
  mounted() {
    this.fetchTrackingLists();
  },
  methods: {
    onFilterChanged: function () {
      this.runFilter();
    },
    runFilter: function () {
      let allowedValues = [];
      for (let key in this.checked) {
        if (this.checked[key]) {
          allowedValues.push(key);
        }
      }
      this.tableFilter.allowedValues = allowedValues;
    },
    cellClicked: function (data) {
      let dataType = data.target.getAttribute('data-type');
      switch (dataType) {
        case 'select':
          this.selectedTrackingList = data.row;
          this.$emit('selectedTrackingList', this.selectedTrackingList);
          break;
      }
    },
    refresh() {
      this.fetchTrackingLists();
    },
    async fetchTrackingLists() {
      this.loading = true;
      const {data} = await TrackingListsRepository.getTrackingListTemplates();
      this.loading = false;
      data.forEach(space => {
        space.action = [
          'select'
        ];
      });
      this.rows = data;
    }
  }
}
</script>

<style lang="scss" scoped>

.top-bar-left {
  display: flex;
  align-items: center;
  width: 100%;
}

.spaces-filter-container {
  width: 100%;
  background-color: white;
  height: 50px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
}

.tab-list {
  margin-bottom: 20px;
}

.loaderContainer {
  height: 20vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep tbody tr td:nth-child(3) {
  padding: 0 15px !important;

  span[class*='icon-']:before {
    top: 4px;
    position: relative;
  }
}

::v-deep .ada-table-container tr {
  display: flex;
}

::v-deep .ada-table-container td {
  display: block;
}

</style>